import { ActionTypes } from "../constants/action-types"

const initialState = {
    prerequisiteById: []
}

const FetchPrerequisiteById = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.FETCH_PREREQUISITE_BY_ID : return {...state, 
            prerequisiteById: payload}           
        default: return state;
    }
    
}


export default FetchPrerequisiteById;